import React from 'react';
import { getBenefits } from '../mockData';
import { Card, CardContent } from './ui/card';
import { TrendingDown, Leaf, Zap, Home } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const iconMap = {
  TrendingDown: TrendingDown,
  Leaf: Leaf,
  Zap: Zap,
  Home: Home
};

const Benefits = () => {
  const { language } = useLanguage();
  const benefits = getBenefits(language);

  return (
    <section id="vorteile" className="py-20 bg-gradient-to-br from-gray-50 to-sky-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fadeInUp">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {language === 'en' ? 'Your ' : 'Ihre '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-sky-600 to-amber-500">
              {language === 'en' ? 'Benefits' : 'Vorteile'}
            </span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {language === 'en' 
              ? 'Invest in your future with sustainable energy technology'
              : 'Investieren Sie in Ihre Zukunft mit nachhaltiger Energietechnologie'}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => {
            const Icon = iconMap[benefit.icon];
            return (
              <Card key={index} className="group hover:shadow-xl transition-all duration-300 border-0 bg-white hover:-translate-y-2 hover-lift animate-fadeInUp" style={{ animationDelay: `${index * 0.15}s` }}>
                <CardContent className="p-8">
                  <div className="w-16 h-16 bg-gradient-to-br from-sky-100 to-amber-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 animate-float" style={{ animationDelay: `${index * 0.5}s` }}>
                    <Icon className="w-8 h-8 text-sky-600" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
